var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgE = function SvgE(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.209,
    height: 46,
    viewBox: "0 0 43.209 45.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.109 26.3a1.11 1.11 0 0 0-1.1 1.1v.2a11.04 11.04 0 0 0 3.5 6.3 11.517 11.517 0 0 0 7.7 2.7 11.978 11.978 0 0 0 6.7-1.7 19.029 19.029 0 0 0 4.1-3.4 1.075 1.075 0 0 1 1.4-.2l6 4.6a.984.984 0 0 1 .3 1.4.1.1 0 0 1-.1.1 20.932 20.932 0 0 1-7.7 5.8 25.136 25.136 0 0 1-9.7 2 25.662 25.662 0 0 1-9.1-1.6 21.163 21.163 0 0 1-12.3-11.7 22.682 22.682 0 0 1-1.8-9.3 24.822 24.822 0 0 1 1.8-9.3 21.449 21.449 0 0 1 12.3-11.7 25.662 25.662 0 0 1 9.1-1.6 20.536 20.536 0 0 1 8.1 1.6 17.751 17.751 0 0 1 6.3 4.5 21.866 21.866 0 0 1 4.1 7.3 33.651 33.651 0 0 1 1.5 10v1.9a1.09 1.09 0 0 1-1 1.1Zm19.6-8.1a1.11 1.11 0 0 0 1.1-1.1V17a9.51 9.51 0 0 0-2.9-6.3c-1.9-1.8-4.5-2.7-7.9-2.7a10.718 10.718 0 0 0-7.6 2.8 11.268 11.268 0 0 0-3.2 6.2 1.115 1.115 0 0 0 .8 1.3h.2Z",
    fill: "#fff"
  })));
};

export default SvgE;